
import { Types } from 'app/actions/company-admin/page-settings';
import utils from 'app/reducers/utils';

const initialState = {
  isSavingAutomaticMatches: false,
  isSavingSearchApprovedNonprofitsOnly: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.SAVE_AUTO_MATCHES}_PENDING`]: (state, action) => {
    return {...state,
      isSavingAutomaticMatches: true,
    };
  },
  [`${Types.SAVE_AUTO_MATCHES}_RESOLVED`]: (state, action) => {
    return {...state,
      isSavingAutomaticMatches: false,
    };
  },
  [`${Types.SAVE_AUTO_MATCHES}_REJECTED`]: (state, action) => {
    return {...state,
      isSavingAutomaticMatches: false,
    };
  },

  [`${Types.SAVE_SEARCH_APPROVED_NONPROFITS_ONLY}_PENDING`]: (state, action) => {
    return {...state,
      isSavingSearchApprovedNonprofitsOnly: true,
    };
  },
  [`${Types.SAVE_SEARCH_APPROVED_NONPROFITS_ONLY}_RESOLVED`]: (state, action) => {
    return {...state,
      isSavingSearchApprovedNonprofitsOnly: false,
    };
  },
  [`${Types.SAVE_SEARCH_APPROVED_NONPROFITS_ONLY}_REJECTED`]: (state, action) => {
    return {...state,
      isSavingSearchApprovedNonprofitsOnly: false,
    };
  },

});

export default reducer;
